import Module from '../utils/Module';
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import ResizeManager from "../utils/ResizeManager";

gsap.registerPlugin(ScrollTrigger);

export default class BlueBannerModule extends Module {
  constructor (options) {
    super(options)

    this.onKeyEnterPress = this.onKeyEnterPress.bind(this);
    this.onClickOpener = this.onClickOpener.bind(this);
    this.collapseBanners = this.collapseBanners.bind(this);
    this.expandBanner = this.expandBanner.bind(this)

    this.DOMEl = options.element;
    this.contentTitle = this.DOMEl.querySelector(".heading__title")
    this.contentText = this.DOMEl.querySelector(".description")
    this.timeline = gsap.timeline().pause();

    this.cards = this.DOMEl.querySelectorAll(".stats-card")
    this.bannerParagraphs = this.DOMEl.querySelectorAll(".stats-card .inner-card__wrapper")
    this.bannerLearnMore = document.querySelectorAll(".stats-card .learn-more");

    this.init();

    ResizeManager.bind('banner-resize', this.onResize.bind(this));
  }

  init () {
    this.collapseBanners();

    this.bannerLearnMore.forEach( button =>{
      button.addEventListener('click', this.onClickOpener);
      button.addEventListener('keypress', this.onKeyEnterPress);
    });

    if(this.contentTitle) this.timeline.to(this.contentTitle, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"});
    if(this.contentText) this.timeline.to(this.contentText, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"}, '-=0.6');

    const scrollTiggerMain = ScrollTrigger.create({
      trigger: this.DOMEl,
      start: "top center+=100",
      onEnter: ()=>{
        this.timeline.play();
      },
      onEnterBack: ()=>{
        this.timeline.play();
      }
    });


    this.cards.forEach( card  => {

      const timeline = gsap.timeline().pause();

      const titleCards = card.querySelector(".card-title")
      const descCards = card.querySelector(".wysiwyg")

      timeline.to(card, {'transform': 'translate3d(0,0,0)', duration: 0.7, ease:"power2.out"});
      if(titleCards) timeline.to(titleCards, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"}, '-=0.6');
      if(descCards) timeline.to(descCards, {css: {'opacity': 1, 'transform': 'translate3d(0,0,0)'}, duration: 0.7, ease: "power2.out"}, '-=0.6');

      const scrollTiggerCards = ScrollTrigger.create({
        trigger: card,
        start: "top center+=100",
        onEnter: ()=>{
          timeline.play();
        },
        onEnterBack: ()=>{
          timeline.play();
        }
      });
    });
  }

  onKeyEnterPress(e) {
    if (e.keyCode === 13) {
      const parentContainer = e.target.closest(".stats-card");
      this.expandBanner(parentContainer);
    }
  }

  onClickOpener(e) {
    const parentContainer = e.target.closest(".stats-card");
    this.expandBanner(parentContainer);
  }

  expandBanner(banner) {
    banner.querySelector('.learn-more').remove();
    banner.classList.add("stats-card--expanded");
    let bannerWrapper = banner.querySelector('.inner-card__wrapper');
    let bannerContent = banner.querySelector('.inner-card-content');
    let expandedHeight = bannerContent.getBoundingClientRect().height;
    bannerWrapper.style.maxHeight = `${expandedHeight}px`;
  }

  collapseBanners() {
    this.bannerParagraphs.forEach( bannerWrapper => {
      let bannerHeight = bannerWrapper.querySelector('.inner-card__main-content').getBoundingClientRect().height;
      bannerWrapper.style.maxHeight = `${bannerHeight}px`;
      bannerWrapper.classList.remove("stats-card--expanded");
    });
  }

  onResize() {
    this.bannerParagraphs.forEach( bannerWrapper =>{
      let banner = bannerWrapper.closest(".stats-card");
      if (banner.classList.contains("stats-card--expanded")) {
        let expandedHeight = bannerWrapper.querySelector('.inner-card-content').getBoundingClientRect().height;
        bannerWrapper.style.maxHeight = `${expandedHeight}px`;
      }else{
        let bannerHeight = bannerWrapper.querySelector('.inner-card__main-content').getBoundingClientRect().height;
        bannerWrapper.style.maxHeight = `${bannerHeight}px`;
      }
    });
  }
}
